/* eslint-disable @typescript-eslint/no-unused-vars */
import { ConcurrencyError, IRListItem } from '@rhybus/api'
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'

import { mpfRListsHttp } from '../../assets/ts/api/mpf-r-lists-http'
import { DueOut, LIST_NAME } from '../../assets/ts/data/dueout/dueout'
import { LIST_NAME as HISTORY_LIST_NAME } from '../../assets/ts/data/dueout/dueout-history'
import { formatUTCDateToLocal } from '../../assets/ts/date-and-time/date-and-time'
import { handleRoute } from '../../assets/ts/general/general'
import {
  CONCURRENCY_ERR_MSG,
  DUEOUTS_ACTIONS,
  DUEOUTS_STATUS,
} from '../../utils/constants/global-constants'
import DialogBox from '../alert/dialog-box'
import Buttons from '../buttons/buttons'
import './pageoverlay.css'

type AcknowledgeDueOut = {
  dueout: DueOut
}

const DueOutAcknowledgePopup = ({ dueout }: AcknowledgeDueOut) => {
  const [showConfirmReload, setShowConfirmReload] = useState<boolean>(false)

  const AcknowledgeDueOut = async () => {
    const date = new Date()

    const dueoutUpdateObj = {
      ItemModified: date,
      ItemModifiedBy: dueout.Customer?.userID,
      StatusCode: DUEOUTS_STATUS.IN_PROGRESS,
      eKey: dueout.eKey,
      eTag: dueout.eTag,
    }

    const dueoutHistoryObj = {
      ActionCode: DUEOUTS_ACTIONS.ACKNOWLEDGED,
      DueOutGUID: dueout.DueOutGUID,
      DueOutID: dueout.DueOutID,
      ItemCreated: date,
      ItemCreatedBy: dueout.Customer?.userID,
      ItemModified: date,
      ItemModifiedBy: dueout.Customer?.userID,
      PreviousStatusCode: dueout.StatusCode,
      SectionCode: dueout.SectionCode,
      ServicingBy: dueout.ServicingBy,
      StatusCode: DUEOUTS_STATUS.IN_PROGRESS,
      UserRole: 'Customer',
    }

    try {
      const dueoutList = await mpfRListsHttp().getList(LIST_NAME)
      const dueoutHistoryList = await mpfRListsHttp().getList(HISTORY_LIST_NAME)

      const successful = await dueoutList.addOrUpdateItem(
        dueoutUpdateObj as IRListItem
      )
      if (successful !== undefined) {
        await dueoutHistoryList.addOrUpdateItem(dueoutHistoryObj as IRListItem)
        location.reload()
      }
    } catch (error) {
      if (error instanceof ConcurrencyError) {
        setShowConfirmReload(true)
      } else {
        console.error(error)
      }
    }
  }

  useEffect(() => {
    // No operation
  }, [dueout])

  return (
    <div className='submitbg' id='pageoverlay'>
      <div className='due-copying'>
        <h2
          aria-label='You are currently viewing Due Out “Need Re-Enlistment Request information” and Due Date “09/28/2021”.'
          className='poppins-semibold font-14 m-0 py-1 title-color31 maxfitcontent '
          tabIndex={0}
        >
          {`You are currently viewing Due Out “${
            dueout['Category/MetadataValue']
          }” and Due Date “${formatUTCDateToLocal(dueout.DueDate)}”.`}
        </h2>
        <h3
          aria-label='Follow the steps to complete'
          className='poppins-medium font-13 title-color2 py-1 maxfitcontent'
          tabIndex={0}
        >
          Follow the steps to complete:
        </h3>
        <ul
          aria-describedby='list'
          className='list-type-none poppins-medium font-12 title-color2 maxfitcontent'
          id='list'
          tabIndex={0}
        >
          <li className='py-1'>1. Review the Due Out</li>
          <li className='py-1'>
            2. Provide necessary information using Files/Discussions
          </li>
          <li className='py-1'>
            3. Click Complete button after you provided all the requested
            information
          </li>
        </ul>
        <div className='d-flex ms-auto w-100'>
          <Buttons
            aria-label='DUE OUT ACKNOWLEDGED'
            className='btn-lg font-12 bgcolor-31 whitetext text-nowrap  poppins-semibold ms-auto text-uppercase mt-2 '
            icon='icon-checked me-2'
            label='DUE OUT ACKNOWLEDGED'
            onClick={AcknowledgeDueOut}
          />
        </div>
      </div>
      {showConfirmReload && (
        <DialogBox
          handleRouteNo={() => handleRoute('cancel', setShowConfirmReload)}
          handleRouteYes={handleRoute}
          message={CONCURRENCY_ERR_MSG}
          primaryText={'Ok'}
          secondaryText={'Cancel'}
        />
      )}
    </div>
  )
}

export default DueOutAcknowledgePopup
